<template lang="pug">
.container
  .row.g-0
    .col-md-2
      .ugo-series
        ul
          li(v-for='item in categories', :key='item.term_id')
            router-link(:to='`/${item.slug}?page=1`', v-html='item.name')

          li
            router-link(to='/all') ALL

    .col-md-10
      header.ugo-header.d-flex
        h2.ugo-series-title(
          :class='{ "is-loading": isLoading }',
          v-html='$options.filters.firstLetterBig(title)'
        )

      .row.g-0.ugo-list.customers-list
        template(v-if='customers.length > 0')
          .product-col.col-md-4.col-6(
            v-for='(item, index) in customers',
            :key='index'
          )
            customer-item(:item='item')
        .p-5(v-else) ไม่พบข้อมูล
      pagination(
        :records='meta.total',
        v-model='page',
        :per-page='12',
        @paginate='pageChange',
        :options='options'
      )
</template>

<script>
import axios from 'axios'
import CustomerItem from '../components/CustomerItem.vue'
import Pagination from 'vue-pagination-2'

export default {
  components: { CustomerItem, Pagination },

  data() {
    return {
      isLoading: false,
      title: '',
      customers: [],
      categories: [],
      meta: {
        total: 0,
      },
      page: 1,
      options: {
        edgeNavigation: true,
        chunk: 5,
        texts: {
          count:
            'Showing {from} to {to} of {count} items|{count} items|One item',
          first: 'first',
          last: 'last',
          nextPage: '›',
          nextChunk: '»',
          prevPage: '‹',
          prevChunk: '«',
        },
      },
    }
  },

  watch: {
    $route() {
      this.fetchCustomer()
    },
  },

  created() {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
  },

  mounted() {
    this.fetchCustomer()
    axios.get(`${UGO.api.url}v1/customer/cat`).then(({ data }) => {
      this.categories = data.data
    })
  },

  methods: {
    fetchCustomer() {
      this.isLoading = true
      axios
        .get(`${UGO.api.url}v1/customer`, {
          params: {
            cat: this.$route.params.slug,
            page: this.$route.query.page ? this.$route.query.page : this.page,
          },
        })
        .then(({ data }) => {
          this.customers = data.data
          this.meta = data.meta
          this.title = data.cat_name
          this.isLoading = false
        })
    },
    pageChange(page) {
      document.querySelector('.page-header').scrollIntoView()
      this.$router.push({
        params: { cat: this.$route.params.slug },
        query: {
          page: page,
        },
      })
    },
  },
}
</script>